<template>
	<div
		class="g-block-divider-gradient g-block-divider-padding"
		:class="{
			'g-block-divider-gradient--edit': editable,
			'is-active': editable && active,
			'g-block-divider-gradient--h5': h5,
			'g-block-divider-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<span
			class="g-block-divider-gradient__line"
			:style="gradientStyle"
			aria-hidden="true"
		></span>
	</div>
</template>

<script>
	import { dividerMixin } from '../shared/dividerMixin.js';

	export default {
		name: 'GBlockDividerGradient',
		mixins: [dividerMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/dividerEditShell.less';

	.g-block-divider-gradient {
		.divider-block-edit-shell();
	}

	.g-block-divider-gradient__line {
		display: block;
		width: 100%;
		height: 1px;
	}

	.g-block-divider-gradient--h5 {
		.g-block-divider-gradient__line {
			height: 0.02rem;
		}
	}
</style>
